export const GOLF_DEFAULT_COURSE_IMAGE_URL = '/static/pay-and-play.jpg';
